import { render, staticRenderFns } from "./tabPane.vue?vue&type=template&id=626b50be&scoped=true"
import script from "./tabPane.vue?vue&type=script&lang=js"
export * from "./tabPane.vue?vue&type=script&lang=js"
import style0 from "./tabPane.vue?vue&type=style&index=0&id=626b50be&prod&lang=scss&scoped=true"
import style1 from "./tabPane.vue?vue&type=style&index=1&id=626b50be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b50be",
  null
  
)

export default component.exports